import { uuidv7 } from 'uuidv7';

export const REQUEST_ID_HEADER = 'X-Request-Id';

export async function apiClient(
	input: URL | RequestInfo,
	init?: RequestInit | undefined
): Promise<Response> {
	const headers = new Headers(init?.headers);

	// Only mint an id when the caller didn't supply one, so the caller keeps the
	// id it sent and can correlate a failed request with the backend's reqId.
	if (!headers.has(REQUEST_ID_HEADER)) {
		headers.set(REQUEST_ID_HEADER, uuidv7());
	}

	return fetch(input, {
		...init,
		headers,
		// To avoid CORS issues, we need to set credentials to include.
		credentials: 'include',
	});
}
